module.exports = __webpack_public_path__ + "img/signin.c89c8b30.png";